import { styled } from '@mui/material';

const PREFIX = 'SignUpConfirmation';

export const signUpConfirmationClasses = {
  root: `${PREFIX}-root`,
  actions: `${PREFIX}-actions`,
  progressBar: `${PREFIX}-progressBar`,
};

export const SignUpConfirmationRoot = styled('div')(({ theme }) => ({
  [`&.${signUpConfirmationClasses.root}`]: {
    minWidth: 500,
    margin: 'auto',
    flexDirection: 'column',
  },

  [`& .${signUpConfirmationClasses.actions}`]: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },

  [`& .${signUpConfirmationClasses.progressBar}`]: {
    padding: `${theme.spacing(8)}px ${theme.spacing(4)}px`,
    minWidth: '500px',
  },
}));